import React from "react";
import onboarding from "services/onboarding/onboarding";
import {miscImages} from "../../../../config/config";
import BasicPage from "../../../common/basicPage/BasicPage";
import ExternalLink from "../../../common/ExternalLink";

interface IAllowMicrophoneAccessProps {
}

export default function MicAccessNeeded({}: IAllowMicrophoneAccessProps) {
  const headerTextContent: string = "Microphone access needed to score your playing"

  return (
    <BasicPage
      headerIcon={miscImages.whiteMicrophone}
      portraitModeHeaderText={headerTextContent}
      content={
        <>
          <h1>{headerTextContent}</h1>
          <p>
            We noticed mic access wasn&apos;t enabled &mdash; no worries! Without it, we can&apos;t hear your piano
            to give feedback. To unlock scoring and progress tracking, enable mic access in your device settings. Or,
            keep exploring and enable it later.
          </p>
          {/*TODO: Replace general Help Center URL with specific page for granting microphone access*/}
          <ExternalLink url={'https://support.playgroundsessions.com/hc/en-us'} title={'Microphone Access Help'} />
        </>
      }
      actionButton={{
        text: "Continue without mic",
        onClick: () => {
          onboarding.completeOnboarding();
        },
        buttonType: "primary",
      }}
    />
  );
}
